import ApiService from "../apiService";

const API_URL = process.env.EMS_API_URL || location.origin;
class SalesFunnel {
  apiService;
  constructor() {
    this.apiService = new ApiService('/api/common/metric/analytics', null, null, API_URL);
  }

  getListData(params) {
    return this.apiService.post(`laboratory-promo`,  {}, {...params, per_page: 10000000});
  }
}

export default new SalesFunnel();
